// extracted by mini-css-extract-plugin
export default {"block":"share-settings_block__R-sjL","shared":"share-settings_shared__WRxfP","rotate":"share-settings_rotate__P4sll"};